import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({datapie}) => {
  const data = {
    labels: ["รอรับดำเนินการ", "กำลังดำเนินการ", "เอกสารเสร็จแล้ว"],
    datasets: [
      {
        label: "เอกสาร",
        data: datapie,
        fill: false,
        backgroundColor: ["#F2A427", "#36A2EB", "#407522"],
        tension: 0.2,
      },
    ],
  };

  return <Pie data={data} />;
};
export default PieChart